import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '../../Api/ChessRestClient';

/**
 * Checks whether the authenticated user already has a stored Lichess OAuth
 * token in the backend (CCLichessProfile.lichess_token is non-null).
 *
 * Returns:
 *   has_token: true  → user has already authorized; proceed directly to sync.
 *   has_token: false → OAuth flow required first.
 */
export default function useLichessAuthStatus() {
  return useQuery<{has_token: boolean}>(
    ['lichessAuthStatus'],
    async () => {
      const response = await ChessRestClient.get(
        '/learning/lichess/auth_status/',
      );
      return response.data;
    },
    {
      // Don't auto-refetch — we only need this on demand
      staleTime: 0,
      cacheTime: 0,
      enabled: false, // triggered manually via refetch()
    },
  );
}
